import { defineThemeVariant } from "@pandacss/dev";

export const whiteLabel = defineThemeVariant({
  semanticTokens: {
    colors: {
      whiteLabel: {
        neutral: {
          DEFAULT: {
            value: {
              _lowContrast: "{colors.charcoal.700}",
              _highContrast: "{colors.white}",
            },
            description:
              "Neutral color for white label, only to be used in token definitions",
          },
          rgb: {
            value: {
              _lowContrast: "36, 37, 37",
              _highContrast: "255, 255, 255",
            },
            description:
              "Helpers to construct transparent colors in token definitions",
            // to construct transparent colors, we could have use color modifier function of panda (ie. {colors.whiteLabel.neutral/80}),
            // but it uses color-mix behind the scenes which is too new for us to use in production (https://caniuse.com/?search=color-mix)
          },
        },
      },
      content: {
        brand: {
          bold: {
            value: "{colors.restaurant}",
          },
          "bold-hover": {
            value: "rgba({colors.restaurant.rgb},0.88)",
          },
          subtle: {
            value: {
              _lowContrast: "rgba({colors.whiteLabel.neutral.rgb},0.80)",
              _highContrast: "rgba({colors.restaurant.rgb},0.80)",
            },
          },
          subtlest: {
            value: {
              _lowContrast: "rgba({colors.whiteLabel.neutral.rgb},0.64)",
              _highContrast: "rgba({colors.restaurant.rgb},0.64)",
            },
          },
          disabled: {
            value: {
              _lowContrast: "rgba({colors.whiteLabel.neutral.rgb},0.48)",
              _highContrast: "rgba({colors.restaurant.rgb},0.32)",
            },
          },
        },
        neutral: {
          bold: {
            value: "{colors.whiteLabel.neutral}",
          },
          "bold-hover": {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.88)",
          },
          subtle: {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.80)",
          },
          subtlest: {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.64)",
          },
          disabled: {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.48)",
          },
        },
      },
      border: {
        brand: {
          "brand-brand": {
            value: "{colors.restaurant}",
          },
          "brand-brand-hover": {
            value: "rgba({colors.restaurant.rgb},0.88)",
          },
          "brand-subtle": {
            value: {
              _lowContrast: "rgba({colors.whiteLabel.neutral.rgb},0.64)",
              _highContrast: "rgba({colors.restaurant.rgb},0.64)",
            },
          },
          "brand-subtlest": {
            value: {
              _lowContrast: "rgba({colors.whiteLabel.neutral.rgb},0.48)",
              _highContrast: "rgba({colors.restaurant.rgb},0.48)",
            },
          },
        },
        "neutral-on-brand": {
          bolder: {
            value: "{colors.whiteLabel.neutral}",
          },
          "bold-hover": {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.72)",
          },
          bold: {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.64)",
          },
          subtle: {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.32)",
          },
          subtlest: {
            value: "rgba({colors.whiteLabel.neutral.rgb},0.16)",
          },
        },
      },
      background: {
        brand: {
          subtle: {
            value: {
              _highContrast: "rgba({colors.restaurant.rgb},0.16)",
              _lowContrast: "rgba({colors.restaurant.rgb},0.32)",
            },
          },
          "subtle-hover": {
            value: "rgba({colors.restaurant.rgb},0.48)",
          },
          bold: {
            value: "{colors.restaurant}",
          },
          "bold-hover": {
            value: "rgba({colors.restaurant.rgb},0.88)",
          },
          disabled: {
            value: "rgba({colors.restaurant.rgb},0.32)",
          },
          "low-contrast": {
            value: "{colors.charcoal.700}",
          },
          "high-contrast": {
            value: "{colors.restaurant}",
          },
          adaptive: {
            value: {
              _lowContrast: "{colors.charcoal.700}",
              _highContrast: "{colors.restaurant}",
            },
          },
        },
        "neutral-on-brand": {
          base: {
            bold: {
              value: "{colors.whiteLabel.neutral}",
            },
            "bold-hover": {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.88)",
            },
            "subtle-hover": {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.32)",
            },
            subtle: {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.24)",
            },
            "subtler-hover": {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.16)",
            },
            subtler: {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.08)",
            },
            "subtlest-hover": {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.08)",
            },
            subtlest: {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.04)",
            },
          },
          disabled: {
            subtlest: {
              value: "{colors.restaurant}",
            },
            subtle: {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.04)",
            },
            bold: {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.16)",
            },
            bolder: {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.24)",
            },
            reversed: {
              value: "rgba({colors.whiteLabel.neutral.rgb},0.16)",
            },
          },
        },
      },
      shadow: {
        brand: {
          value: {
            _lowContrast: "rgba({colors.restaurant.rgb},0.32)",
            _highContrast: "rgba({colors.restaurant.rgb},0.16)",
          },
        },
        neutral: {
          value: {
            _lowContrast: "rgba({colors.whiteLabel.neutral.rgb},0.16)",
            _highContrast: "rgba({colors.whiteLabel.neutral.rgb},0.32)",
          },
        },
      },
    },
    shadows: {
      effect: {
        "focus-ring": {
          brand: {
            value: "0 0 0 4px {colors.shadow.brand}",
          },
          neutral: {
            value: "0 0 0 4px {colors.shadow.neutral}",
          },
        },
      },
    },
  },
});
